import queryString from 'query-string';
import { getSellerCustomDomain } from './getSellerDomain';

export default function getCustomDomainCheckoutUrl(
  page = {},
  seller = {},
  { isTesting = false, isPreview = false } = {},
) {
  if (!seller.customDomain || !seller.customDomainVerified) return;

  const pageUrlId = page.slug || page._id;

  const domain = getSellerCustomDomain(seller);

  const checkoutUrl = `${domain}/${pageUrlId}`;

  return queryString.stringifyUrl({
    url: checkoutUrl,
    query: {
      ...(isTesting && { testing: true }),
      ...(isPreview && { preview: true }),
    },
  });
}
